export const GET_MONTHLY_SUPPORTS = "GET_MONTHLY_SUPPORTS";
export const GET_MONTHLY_SUPPORT_BY_ID = "GET_MONTHLY_SUPPORT_BY_ID";
export const GET_MONTHLY_SUPPORT_TIMELOGS = "GET_MONTHLY_SUPPORT_TIMELOGS";
export const UPDATE_MONTHLY_SUPPORT = "UPDATE_MONTHLY_SUPPORT";
export const DELETE_MONTHLY_SUPPORT = "DELETE_MONTHLY_SUPPORT";
export const CREATE_MONTHLY_SUPPORT = "CREATE_MONTHLY_SUPPORT";
export const PREVIEW_MONTHLY_SUPPORT = "PREVIEW_MONTHLY_SUPPORT";
export const GET_MONTHLY_SUPPORT_INVOICE = "GET_MONTHLY_SUPPORT_INVOICE";
